import { useEffect, useState } from 'react'
import { SnackbarContent, Typography } from '@tino-frontend/coreui'
import { AlertIcon, DoneIcon, InfoIcon } from '@tino-frontend/icons'

import { useAlert } from '../hooks'
import { STORE_STATUS_FINISHED } from 'constants/store'
import { SnackbarRoot, AlertRoot } from './alert.styles'

export function Alert() {
  const [openAlert, setOpenAlert] = useState(false)
  const { alert, clear } = useAlert()

  function handleOnClose() {
    setOpenAlert(false)
    clear()
  }

  function handleAnimationEnd() {
    clear()
  }

  function getIcon() {
    switch (alert.data.type) {
      case 'success':
        return <DoneIcon color="success.dark" />
      case 'error':
        return <AlertIcon color="error.dark" />
      case 'info':
        return <InfoIcon />
      case 'warning':
        return <InfoIcon color="warning.dark" />
      default:
        return null
    }
  }

  useEffect(() => {
    setOpenAlert(alert.status === STORE_STATUS_FINISHED)
  }, [alert.status])

  return (
    <SnackbarRoot
      anchorOrigin={alert.data.anchorOrigin}
      open={openAlert}
      onAnimationEnd={handleAnimationEnd}
      onClose={handleOnClose}
      autoHideDuration={alert.data.autoHideDuration}
    >
      {alert.data.type === 'default' ? (
        <SnackbarContent message={alert.data.title || alert.data.description} />
      ) : (
        <AlertRoot
          icon={getIcon()}
          onClose={handleOnClose}
          severity={alert.data.type}
        >
          <Typography variant="body1" fontWeight="normal" component="p">
            {alert.data.title || alert.data.description}
          </Typography>
          {alert.data.title && (
            <Typography variant="body3" mt={1.5}>
              {alert.data.description}
            </Typography>
          )}
        </AlertRoot>
      )}
    </SnackbarRoot>
  )
}
